var rich_content_viewer_default = {
  "fontElementMap": "x0OB4",
  "wrapper": "C0FQi",
  "pluginContainerMobile": "X1UFN",
  "viewer": "LZNQc",
  "android": "_32kcL",
  "rootedTraversedContent": "oLw7q",
  "atomic": "_2KUm1",
  "toolbar": "JtcP-",
  "block": "FqHXW"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
